/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropvalidationtermsrequired3Inputs */

const en_dropvalidationtermsrequired3 = /** @type {(inputs: Dropvalidationtermsrequired3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms are required`)
};

const de_dropvalidationtermsrequired3 = /** @type {(inputs: Dropvalidationtermsrequired3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilnahmebedingungen sind erforderlich`)
};

/**
* | output |
* | --- |
* | "Terms are required" |
*
* @param {Dropvalidationtermsrequired3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropvalidationtermsrequired3 = /** @type {((inputs?: Dropvalidationtermsrequired3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropvalidationtermsrequired3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropvalidationtermsrequired3(inputs)
	return de_dropvalidationtermsrequired3(inputs)
});
export { dropvalidationtermsrequired3 as "dropValidationTermsRequired" }